__turbopack_context__.v({
  "aboutFishplace": "WhoAreWeSection-module-scss-module__otUCxG__aboutFishplace",
  "title": "WhoAreWeSection-module-scss-module__otUCxG__title",
  "video": "WhoAreWeSection-module-scss-module__otUCxG__video",
  "whoAreWe": "WhoAreWeSection-module-scss-module__otUCxG__whoAreWe",
});
